
import React from "react";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface BusinessDescriptionProps {
  description: string;
  updateBusinessData: (key: string, value: string) => void;
}

const BusinessDescription: React.FC<BusinessDescriptionProps> = ({
  description,
  updateBusinessData
}) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="description">Business Description</Label>
      <Textarea
        id="description"
        placeholder="Tell us what your business does..."
        className="resize-none"
        rows={4}
        value={description}
        onChange={(e) => updateBusinessData("description", e.target.value)}
      />
    </div>
  );
};

export default BusinessDescription;
